import type { TopicKey } from '@pages/PracticePage/model';
import { getPracticeTopic, PracticeViewProvider } from '@pages/PracticePage/model';

import { DashboardContainer } from '@shared/ui/layouts';

import { PerformanceOverview, PracticeHero, PracticeLessons, SubskillsGrid } from './components';

interface PracticePageProps {
  topic?: TopicKey;
}

export const PracticePage = ({ topic }: PracticePageProps) => {
  const { config } = getPracticeTopic(topic);

  return (
    <PracticeViewProvider>
      <div className="w-full">
        <PracticeHero
          title={config.title}
          subtitle={config.subtitle}
          description={config.description}
          audioGuide={config.audioGuide}
          audioDuration={config.audioDuration}
        />

        <DashboardContainer>
          <div className="grid max-w-full grid-cols-1 gap-4 lg:grid-cols-10 lg:items-start">
            <div className="flex flex-col gap-8 lg:col-span-7 mr-6">
              <SubskillsGrid subskills={config.subskills} />
              <PracticeLessons groups={config.groups} />
            </div>

            <div className="lg:col-span-3">
              <PerformanceOverview performance={config.performance} />
            </div>
          </div>
        </DashboardContainer>
      </div>
    </PracticeViewProvider>
  );
};
